import { useState } from 'react';
import { motion } from 'framer-motion';
import { useTextScramble } from '../hooks/useTextScramble';

const FeatureCard = ({ title, subtitle, description, index, isLast, isMobile }) => {
  const [isHovered, setIsHovered] = useState(false);
  const scrambledTitle = useTextScramble(title, true);

  const cardStyle = {
    position: 'relative',
    padding: isMobile ? '24px 20px' : '32px',
    minHeight: isMobile ? 180 : 220,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    cursor: 'pointer',
    borderRight: !isLast ? '1px solid rgba(242,242,242,0.2)' : 'none',
    borderBottom: isMobile && !isLast ? '1px solid rgba(242,242,242,0.2)' : 'none',
    backgroundColor: isHovered ? '#F2F2F2' : '#050505',
  };

  const titleStyle = {
    fontSize: 18,
    fontWeight: 600,
    letterSpacing: '-0.02em',
    textTransform: 'uppercase',
    marginBottom: 8,
    color: isHovered ? '#050505' : '#F2F2F2',
  };

  const subtitleStyle = {
    fontSize: isMobile ? 12 : 11,
    fontWeight: 500,
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
    marginBottom: 16,
    color: isHovered ? '#050505' : 'rgba(0,255,65,0.8)',
    opacity: isHovered ? 0.7 : 1,
  };

  const descStyle = {
    fontSize: isMobile ? 12 : 11,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    lineHeight: 1.7,
    color: isHovered ? '#050505' : '#F2F2F2',
    opacity: isHovered ? 1 : 0,
    height: isHovered ? 'auto' : 0,
    overflow: 'hidden',
  };

  const dotStyle = {
    width: 8,
    height: 8,
    backgroundColor: isHovered ? '#00FF41' : 'rgba(0,255,65,0.5)',
  };

  return (
    <motion.div
      data-hover
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={cardStyle}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.1, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
    >
      <div>
        <h3 style={titleStyle}>{scrambledTitle}</h3>
        <p className="font-mono" style={subtitleStyle}>
          {subtitle}
        </p>
        <p className="font-mono" style={descStyle}>
          {description}
        </p>
      </div>
      <div style={dotStyle} />
    </motion.div>
  );
};

export default FeatureCard;
